import React from 'react'
import { observer } from 'mobx-react'
import { IonText } from '@ionic/react'
import styled from 'styled-components'
type Props = {
  type:
    | 'b_28'
    | 'm_28'
    | 'b_24'
    | 'm_24'
    | 'b_20'
    | 'm_20'
    | 'b_18'
    | 'm_18'
    | 'r_18'
    | 'b_16'
    | 'm_16'
    | 'r_16'
    | 'b_15'
    | 'm_15'
    | 'r_15'
    | 'b_14'
    | 'm_14'
    | 'r_14'
    | 'b_13'
    | 'sb_13'
    | 'm_13'
    | 'r_13'
    | 'b_12'
    | 'sb_12'
    | 'm_12'
    | 'r_12'
    | 'b_11'
    | 'sb_11'
    | 'm_11'
    | 'r_11'
    | 'b_8'
    | 'm_8'
  color?:
    | 'primary_light'
    | 'primary_main'
    | 'primary_dark'
    | 'secondary_light'
    | 'secondary_main'
    | 'secondary_dark'
    | 'error_tint'
    | 'error_light'
    | 'error_main'
    | 'error_dark'
    // | 'success_tint'
    | 'success_light'
    | 'success_main'
    // | 'success_dark'
    // | 'surface_white'
    // | 'light_gray'
    // | 'medium_gray'
    // | 'gray'
    // | 'special_gray'
    // | 'dark_gray'
    // | 'dark_gray2'
    // | 'primary_black'
    | 'white'
    | 'gray100'
    | 'gray200'
    | 'gray300'
    | 'gray400'
    // | 'gray500'
    | 'gray600'
    | 'gray700'
  // | 'gray800'
  // | 'black'
  style?: React.CSSProperties
}
export const TextStyle: React.FC<Props> = observer(({ type, children, color, style }) => {
  return (
    <StyleText>
      <IonText style={{ ...style }} color={color} className={type}>
        {children}
      </IonText>
    </StyleText>
  )
})
const StyleText = styled.span`
  white-space: pre-wrap;
  .b_28 {
    font-weight: 700;
    font-size: 28px;
  }
  .m_28 {
    font-weight: 500;
    font-size: 28px;
  }
  .b_24 {
    font-weight: 700;
    font-size: 24px;
  }
  .m_24 {
    font-weight: 500;
    font-size: 24px;
  }
  .b_20 {
    font-weight: 700;
    font-size: 20px;
  }
  .m_20 {
    font-weight: 500;
    font-size: 20px;
  }
  .b_18 {
    font-weight: 700;
    font-size: 18px;
  }
  .m_18 {
    font-weight: 500;
    font-size: 18px;
  }
  .r_18 {
    font-weight: 400;
    font-size: 18px;
  }
  .b_16 {
    font-weight: 700;
    font-size: 16px;
  }
  .m_16 {
    font-weight: 500;
    font-size: 16px;
  }
  .r_16 {
    font-weight: 400;
    font-size: 16px;
  }
  .b_15 {
    font-weight: 700;
    font-size: 15px;
  }
  .m_15 {
    font-weight: 500;
    font-size: 15px;
  }
  .r_15 {
    font-weight: 400;
    font-size: 15px;
  }
  .b_14 {
    font-weight: 700;
    font-size: 14px;
  }
  .m_14 {
    font-weight: 500;
    font-size: 14px;
  }
  .r_14 {
    font-weight: 400;
    font-size: 14px;
  }
  .b_13 {
    font-weight: 700;
    font-size: 13px;
  }
  .sb_13 {
    font-weight: 600;
    font-size: 13px;
  }
  .m_13 {
    font-weight: 500;
    font-size: 13px;
  }
  .r_13 {
    font-weight: 400;
    font-size: 13px;
  }
  .b_12 {
    font-weight: 700;
    font-size: 12px;
  }
  .sb_12 {
    font-weight: 600;
    font-size: 12px;
  }
  .m_12 {
    font-weight: 500;
    font-size: 12px;
  }
  .r_12 {
    font-weight: 400;
    font-size: 12px;
  }
  .b_11 {
    font-weight: 700;
    font-size: 11px;
  }
  .sb_11 {
    font-weight: 600;
    font-size: 11px;
  }
  .m_11 {
    font-weight: 500;
    font-size: 11px;
  }
  .r_11 {
    font-weight: 400;
    font-size: 11px;
  }
  .b_8 {
    font-weight: 700;
    font-size: 8px;
  }
  .m_8 {
    font-weight: 500;
    font-size: 8px;
  }
`
